import React from 'react';
import { Button } from 'reactstrap';
import { withTranslation } from 'react-multi-lang';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle, faRotateRight } from "@fortawesome/free-solid-svg-icons";

const NoSystemCommunication = (attributes) => {
    const errorMessage = attributes.errorMessage;
    const checkAgain = attributes.checkAgain;

    return (
        <div className="offline-wrapper">
            <div className="offline-card">
                <div className="offline-logo-container">
                    <img src="/logo512.png" alt="Nordia Logo" />
                </div>
                <div className="offline-alert-box">
                    <div className="d-flex align-items-center gap-2 font-weight-bold mb-1">
                        <FontAwesomeIcon icon={faExclamationTriangle} />
                        <span>Σφάλμα Επικοινωνίας</span>
                    </div>
                    <div>{errorMessage || 'Δεν ήταν δυνατή η σύνδεση με το κεντρικό σύστημα.'}</div>
                </div>
                <Button color="primary" onClick={checkAgain} className="px-4 py-2">
                    <FontAwesomeIcon icon={faRotateRight} className="me-2" />
                    Επανάληψη Σύνδεσης
                </Button>
            </div>
        </div>
    );
};

export default withTranslation(NoSystemCommunication);
